import universal from 'react-universal-component';

export const ConfettiOverlay = universal(() => import('Components/confetti/ConfettiOverlay'), {
  ignoreBabelRename: true,
  loading: <></>,
  loadingTransition: false,
});
